/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { CreateContentReportDto } from "../models";
/**
 * ContentReportApi - axios parameter creator
 * @export
 */
export const ContentReportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateContentReportDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentReportControllerCreateReports: async (
      body: CreateContentReportDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling contentReportControllerCreateReports."
        );
      }
      const localVarPath = `/v1/cms/api/content-report`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} contentKey
     * @param {string} userKey
     * @param {any} playbackProblem
     * @param {string} subtitleProblem
     * @param {string} audioProblem
     * @param {string} customReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentReportControllerGetReports: async (
      pageNumber: number,
      pageIndex: number,
      contentKey: string,
      userKey: string,
      playbackProblem: any,
      subtitleProblem: string,
      audioProblem: string,
      customReport: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'contentKey' is not null or undefined
      if (contentKey === null || contentKey === undefined) {
        throw new RequiredError(
          "contentKey",
          "Required parameter contentKey was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'userKey' is not null or undefined
      if (userKey === null || userKey === undefined) {
        throw new RequiredError(
          "userKey",
          "Required parameter userKey was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'playbackProblem' is not null or undefined
      if (playbackProblem === null || playbackProblem === undefined) {
        throw new RequiredError(
          "playbackProblem",
          "Required parameter playbackProblem was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'subtitleProblem' is not null or undefined
      if (subtitleProblem === null || subtitleProblem === undefined) {
        throw new RequiredError(
          "subtitleProblem",
          "Required parameter subtitleProblem was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'audioProblem' is not null or undefined
      if (audioProblem === null || audioProblem === undefined) {
        throw new RequiredError(
          "audioProblem",
          "Required parameter audioProblem was null or undefined when calling contentReportControllerGetReports."
        );
      }
      // verify required parameter 'customReport' is not null or undefined
      if (customReport === null || customReport === undefined) {
        throw new RequiredError(
          "customReport",
          "Required parameter customReport was null or undefined when calling contentReportControllerGetReports."
        );
      }
      const localVarPath = `/v1/cms/api/content-report`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (contentKey !== undefined) {
        localVarQueryParameter["contentKey"] = contentKey;
      }

      if (userKey !== undefined) {
        localVarQueryParameter["userKey"] = userKey;
      }

      if (playbackProblem !== undefined) {
        localVarQueryParameter["playbackProblem"] = playbackProblem;
      }

      if (subtitleProblem !== undefined) {
        localVarQueryParameter["subtitleProblem"] = subtitleProblem;
      }

      if (audioProblem !== undefined) {
        localVarQueryParameter["audioProblem"] = audioProblem;
      }

      if (customReport !== undefined) {
        localVarQueryParameter["customReport"] = customReport;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContentReportApi - functional programming interface
 * @export
 */
export const ContentReportApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateContentReportDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentReportControllerCreateReports(
      body: CreateContentReportDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentReportApiAxiosParamCreator(
        configuration
      ).contentReportControllerCreateReports(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} contentKey
     * @param {string} userKey
     * @param {any} playbackProblem
     * @param {string} subtitleProblem
     * @param {string} audioProblem
     * @param {string} customReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentReportControllerGetReports(
      pageNumber: number,
      pageIndex: number,
      contentKey: string,
      userKey: string,
      playbackProblem: any,
      subtitleProblem: string,
      audioProblem: string,
      customReport: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentReportApiAxiosParamCreator(
        configuration
      ).contentReportControllerGetReports(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        playbackProblem,
        subtitleProblem,
        audioProblem,
        customReport,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ContentReportApi - factory interface
 * @export
 */
export const ContentReportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {CreateContentReportDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentReportControllerCreateReports(
      body: CreateContentReportDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentReportApiFp(configuration)
        .contentReportControllerCreateReports(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} contentKey
     * @param {string} userKey
     * @param {any} playbackProblem
     * @param {string} subtitleProblem
     * @param {string} audioProblem
     * @param {string} customReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentReportControllerGetReports(
      pageNumber: number,
      pageIndex: number,
      contentKey: string,
      userKey: string,
      playbackProblem: any,
      subtitleProblem: string,
      audioProblem: string,
      customReport: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentReportApiFp(configuration)
        .contentReportControllerGetReports(
          pageNumber,
          pageIndex,
          contentKey,
          userKey,
          playbackProblem,
          subtitleProblem,
          audioProblem,
          customReport,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContentReportApi - object-oriented interface
 * @export
 * @class ContentReportApi
 * @extends {BaseAPI}
 */
export class ContentReportApi extends BaseAPI {
  /**
   *
   * @param {CreateContentReportDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentReportApi
   */
  public async contentReportControllerCreateReports(
    body: CreateContentReportDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentReportApiFp(this.configuration)
      .contentReportControllerCreateReports(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} contentKey
   * @param {string} userKey
   * @param {any} playbackProblem
   * @param {string} subtitleProblem
   * @param {string} audioProblem
   * @param {string} customReport
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentReportApi
   */
  public async contentReportControllerGetReports(
    pageNumber: number,
    pageIndex: number,
    contentKey: string,
    userKey: string,
    playbackProblem: any,
    subtitleProblem: string,
    audioProblem: string,
    customReport: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentReportApiFp(this.configuration)
      .contentReportControllerGetReports(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        playbackProblem,
        subtitleProblem,
        audioProblem,
        customReport,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
